import SEO from "@/components/SEO";
import { FadeUp, Eyebrow } from "@/components/Reveal";

const UPDATED_IT = "Ultimo aggiornamento: 4 ottobre 2026";
const UPDATED_EN = "Last updated: 4 October 2026";

const CONTENT = {
  it: {
    eyebrow: "Informazioni legali",
    privacy: {
      title: "Privacy Policy",
      desc: "Privacy Policy di Zaichauffer – trattamento dei dati personali per la gestione delle richieste di preventivo (GDPR).",
      intro:
        "La presente informativa, resa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 («GDPR»), descrive il trattamento dei dati personali degli utenti che visitano il sito e che compilano il modulo di richiesta preventivo o contattano il titolare tramite i canali indicati.",
      sections: [
        {
          h: "1. Titolare del trattamento",
          ps: [
            "Khalid El Aissaoui — Zaichauffer. Email: info@zaichauffeur.it · Tel./WhatsApp: +39 3208189469.",
          ],
        },
        {
          h: "2. Dati trattati e finalità",
          ps: [
            "a) Dati di richiesta — nome, indirizzo email, numero di telefono, località di partenza e destinazione, data e ora del trasferimento ed eventuali note inseriti nel modulo di richiesta preventivo o comunicati per email/WhatsApp. Finalità: gestire e dare seguito alla richiesta, definire il servizio e contattare il richiedente. Base giuridica: esecuzione di misure precontrattuali su richiesta dell'interessato (art. 6, c. 1, lett. b GDPR).",
            "b) Dati necessari all'esecuzione del servizio — qualora la richiesta si trasformi in incarico, i dati utili all'esecuzione del trasporto e agli adempimenti contrattuali, contabili e fiscali (inclusa la fatturazione). Base giuridica: esecuzione del contratto e obblighi legali (art. 6, c. 1, lett. b e c GDPR).",
            "c) Dati di navigazione — indirizzo IP, tipo di browser e parametri tecnici raccolti in via transitoria dai sistemi informatici nei limiti necessari alla sicurezza e al corretto funzionamento del sito. Base giuridica: legittimo interesse (art. 6, c. 1, lett. f GDPR).",
          ],
        },
        {
          h: "3. Modalità del trattamento",
          ps: [
            "I dati sono trattati con strumenti elettronici e secondo logiche strettamente correlate alle finalità indicate, con misure di sicurezza adeguate a proteggerli da accessi non autorizzati. L'accesso ai dati è limitato al titolare e ai fornitori tecnici che li trattano in qualità di responsabili o titolari autonomi.",
          ],
        },
        {
          h: "4. Tempi di conservazione",
          ps: [
            "Le richieste non seguite da incarico sono conservate per un massimo di 12 mesi dall'ultimo contatto e successivamente cancellate. I dati contrattuali e di fatturazione sono conservati per 10 anni, in forza degli obblighi civilistici e fiscali. I dati di navigazione sono conservati per il periodo tecnico di conservazione dei log dei server.",
          ],
        },
        {
          h: "5. Destinatari dei dati",
          ps: [
            "I dati sono trattati esclusivamente dal titolare e da fornitori tecnici limitatamente a quanto necessario all'erogazione del servizio: fornitore del servizio di invio email transazionale (Resend), fornitore di hosting e database, provider di reti di distribuzione dei contenuti per caratteri tipografici e immagini. I dati non sono diffusi né ceduti a terzi per finalità di marketing. L'elenco aggiornato dei responsabili è disponibile su richiesta scrivendo al titolare.",
          ],
        },
        {
          h: "6. Trasferimento dei dati fuori dall'UE",
          ps: [
            "Alcuni dei fornitori tecnici indicati potrebbero avere sede o server fuori dallo Spazio economico europeo. In tali casi il trasferimento avviene nel rispetto del Capo V del GDPR, mediante decisioni di adeguatezza della Commissione Europea o clausole contrattuali standard.",
          ],
        },
        {
          h: "7. Natura del conferimento",
          ps: [
            "Il conferimento dei dati richiesti dal modulo è facoltativo, ma necessario per poter gestire la richiesta: in mancanza non è possibile fornire il preventivo o rispondere al contatto. Il rifiuto di comunicare dati necessari agli adempimenti legali (es. fatturazione) impedisce l'esecuzione del servizio.",
          ],
        },
        {
          h: "8. Diritti dell'interessato",
          ps: [
            "In relazione al trattamento descritto l'interessato può esercitare in ogni momento i diritti previsti dagli artt. 15-22 del GDPR: accesso, rettifica, integrazione, cancellazione, limitazione, opposizione, portabilità dei dati e revoca del consenso eventualmente conferito.",
            "Per esercitare i propri diritti è sufficiente scrivere a info@zaichauffeur.it. L'interessato ha inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
          ],
        },
        {
          h: "9. Modifiche alla presente informativa",
          ps: [
            "L'informativa può essere modificata in qualsiasi momento, in particolare in caso di nuovi servizi o fornitori. La versione pubblicata su questa pagina è quella attualmente in vigore.",
          ],
        },
      ],
    },
    cookie: {
      title: "Cookie Policy",
      desc: "Cookie Policy di Zaichauffer – uso di cookie e tecnologie simili sul sito.",
      intro:
        "I cookie sono piccoli file che i siti salvano sul dispositivo dell'utente per garantirne il funzionamento o raccogliere informazioni sulla navigazione. Questa pagina descrive l'uso dei cookie e di tecnologie simili su questo sito.",
      sections: [
        {
          h: "1. Cookie utilizzati da questo sito",
          ps: [
            "Questo sito non utilizza cookie di profilazione, marketing o tracciamento di alcun tipo e non installa strumenti di analisi statistica di terze parti. Non è pertanto presente un banner di consenso: il sito funziona senza cookie che lo richiedano.",
            "Nel caso della versione WordPress del sito possono essere installati esclusivamente cookie tecnici (es. cookie di sessione o di preferenze di visualizzazione) necessari al corretto funzionamento delle pagine, per i quali la normativa vigente non richiede il consenso dell'utente.",
          ],
        },
        {
          h: "2. Servizi di terze parti",
          ps: [
            "Il sito carica caratteri tipografici e immagini da reti di distribuzione di contenuti esterne (tra cui Google Fonts e Unsplash): al momento del caricamento, l'indirizzo IP dell'utente viene comunicato ai rispettivi fornitori ai soli fini della distribuzione del contenuto. Tali servizi non installano cookie di profilazione tramite questo sito.",
            "Il pulsante WhatsApp presente sul sito rimanda a una piattaforma esterna gestita da Meta: su tale piattaforma si applicano le relative informative privacy e cookie di terzi.",
          ],
        },
        {
          h: "3. Gestione dei cookie",
          ps: [
            "L'utente può controllare, limitare ed eliminare i cookie dalle impostazioni del proprio browser (Chrome, Firefox, Safari, Edge). La disattivazione dei cookie tecnici può limitare alcune funzionalità del sito.",
          ],
        },
        {
          h: "4. Aggiornamenti",
          ps: [
            "La presente Cookie Policy può essere modificata in qualsiasi momento. La versione pubblicata su questa pagina è quella attualmente in vigore.",
          ],
        },
      ],
    },
  },
  en: {
    eyebrow: "Legal information",
    privacy: {
      title: "Privacy Policy",
      desc: "Privacy Policy of Zaichauffer – processing of personal data for the purpose of handling quote requests (GDPR).",
      intro:
        "This notice, provided pursuant to Art. 13 of Regulation (EU) 2016/679 («GDPR»), describes the processing of personal data of users who visit the website and who fill in the quote request form or contact the owner through the channels indicated.",
      sections: [
        {
          h: "1. Data controller",
          ps: [
            "Khalid El Aissaoui — Zaichauffer. Email: info@zaichauffeur.it · Tel./WhatsApp: +39 3208189469.",
          ],
        },
        {
          h: "2. Data processed and purposes",
          ps: [
            "a) Request data — name, email address, phone number, pick-up and destination locations, transfer date and time, and any notes entered in the quote request form or communicated by email/WhatsApp. Purpose: handling and following up on the request, defining the service and contacting the requester. Legal basis: pre-contractual measures taken at the request of the data subject (Art. 6(1)(b) GDPR).",
            "b) Data required to perform the service — should the request turn into an engagement, the data needed to carry out the transfer and to comply with contractual, accounting and tax obligations (including invoicing). Legal basis: performance of the contract and legal obligations (Art. 6(1)(b) and (c) GDPR).",
            "c) Browsing data — IP address, browser type and technical parameters collected on a temporary basis by the IT systems to the extent necessary for the security and proper functioning of the website. Legal basis: legitimate interest (Art. 6(1)(f) GDPR).",
          ],
        },
        {
          h: "3. Method of processing",
          ps: [
            "Data are processed by electronic means and according to logic strictly related to the stated purposes, with appropriate security measures in place to prevent unauthorised access. Access to the data is limited to the owner and to the technical suppliers who process them as data processors or independent controllers.",
          ],
        },
        {
          h: "4. Data retention",
          ps: [
            "Requests not followed by an engagement are retained for no more than 12 months from the last contact and subsequently deleted. Contractual and invoicing data are retained for 10 years, pursuant to civil and tax obligations. Browsing data are retained for the technical retention period of the server logs.",
          ],
        },
        {
          h: "5. Data recipients",
          ps: [
            "Data are processed exclusively by the owner and by technical suppliers to the extent necessary to deliver the service: transactional email service provider (Resend), hosting and database provider, and content delivery networks for web fonts and images. Data are not disclosed or transferred to third parties for marketing purposes. The updated list of data processors is available on request by writing to the owner.",
          ],
        },
        {
          h: "6. Transfer of data outside the EU",
          ps: [
            "Some of the technical suppliers mentioned may be located outside the European Economic Area. In such cases the transfer takes place in compliance with Chapter V of the GDPR, by means of adequacy decisions or standard contractual clauses.",
          ],
        },
        {
          h: "7. Nature of the provision of data",
          ps: [
            "Providing the data requested by the form is optional but necessary in order to process the request: without it, no quote can be provided and the message cannot be answered. Refusal to provide data required by law (e.g. invoicing) prevents the performance of the service.",
          ],
        },
        {
          h: "8. Data subject rights",
          ps: [
            "In relation to the processing described above, data subjects may exercise at any time the rights set out in Articles 15-22 of the GDPR: access, rectification, erasure, restriction, objection, data portability and withdrawal of any consent given.",
            "To exercise these rights simply write to info@zaichauffeur.it. Data subjects also have the right to lodge a complaint with the Italian Data Protection Authority (www.garanteprivacy.it).",
          ],
        },
        {
          h: "9. Changes to this notice",
          ps: [
            "This notice may be amended at any time, in particular where new services or suppliers are introduced. The version published on this page is the one currently in force.",
          ],
        },
      ],
    },
    cookie: {
      title: "Cookie Policy",
      desc: "Cookie Policy of Zaichauffer – use of cookies and similar technologies on the website.",
      intro:
        "Cookies are small files that websites store on a user's device to ensure their operation or to collect information about browsing. This page describes the use of cookies and similar technologies on this website.",
      sections: [
        {
          h: "1. Cookies used by this website",
          ps: [
            "This website does not use profiling, marketing or tracking cookies of any kind and does not install third-party analytics tools. No consent banner is therefore displayed: the website works without cookies that would require one.",
            "In the case of the WordPress version of the website, only technical cookies (e.g. session or display-preference cookies) necessary for the proper functioning of the pages may be installed; under the applicable legislation such cookies do not require the user's consent.",
          ],
        },
        {
          h: "2. Third-party services",
          ps: [
            "The website loads web fonts and images from external content delivery networks (including Google Fonts and Unsplash): upon loading, the user's IP address is communicated to the respective providers solely for the purpose of delivering the content. Such services do not install profiling cookies through this website.",
            "The WhatsApp button on the website links to an external platform operated by Meta: the privacy and cookie policies of that third party apply on such platform.",
          ],
        },
        {
          h: "3. Managing cookies",
          ps: [
            "Users can control, limit and delete cookies in the settings of their browser (Chrome, Firefox, Safari, Edge). Disabling technical cookies may limit some of the website's features.",
          ],
        },
        {
          h: "4. Updates",
          ps: [
            "This Cookie Policy may be amended at any time. The version published on this page is the one currently in force.",
          ],
        },
      ],
    },
  },
};

export default function Legal({ page, lang = "it" }) {
  const en = lang === "en";
  const data = CONTENT[lang][page];

  return (
    <>
      <SEO title={`${data.title} | Zaichauffer`} description={data.desc} />
      <section className="mx-auto max-w-3xl px-6 pb-32 pt-40 md:pt-52" data-testid="legal-page">
        <FadeUp>
          <Eyebrow>{CONTENT[lang].eyebrow}</Eyebrow>
          <h1 className="mt-10 font-serif text-4xl tracking-tight text-bone sm:text-5xl">
            {data.title.toUpperCase()}
          </h1>
          <p className="mt-6 text-xs font-light text-mute">
            {en ? UPDATED_EN : UPDATED_IT}
          </p>
        </FadeUp>
        <FadeUp delay={0.15}>
          <div className="mt-12 border border-white/10 bg-coal p-8 md:p-14">
            <p className="text-[15px] font-light leading-relaxed text-mute">
              {data.intro}
            </p>
            <div className="mt-12 space-y-12">
              {data.sections.map((s) => (
                <div key={s.h}>
                  <h2 className="font-serif text-lg tracking-wide text-bone md:text-xl">
                    {s.h.toUpperCase()}
                  </h2>
                  <div className="mt-5 space-y-4">
                    {s.ps.map((p, i) => (
                      <p
                        key={i}
                        className="text-sm font-light leading-relaxed text-bone/75"
                      >
                        {p}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </FadeUp>
      </section>
    </>
  );
}
